export const MeasuresPage = () => {
  return (
    <div className="bg-gray-50 h-full w-full px-8 py-8">
      <h1>Measures</h1>
    </div>
  )
}
